import React from 'react';
import { useTranslation } from 'react-i18next';
import translations from 'services/translations/translations';

/**
 * Shown after signing out of EWorkbook. Signing in again needs no password while
 * the Entra session lasts.
 */
const SignedOut = (): JSX.Element => {
  const { t } = useTranslation([translations.common]);
  return (
    <div className="centered-container">
      <h2>{t(`${translations.common}:Signed out`)}</h2>
      <a href="/">{t(`${translations.common}:Sign in again`)}</a>
    </div>
  );
};

export default SignedOut;
